exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width:768px){[class*=guillemets][data-v-eb1e0b42]{height:1.875rem;width:1.875rem}}@media (min-width:992px){[class*=guillemets][data-v-eb1e0b42]{height:2.5rem;width:2.5rem}}", ""]);

